import type Highcharts from "highcharts";

export default function fixOnSeriesEvents(H: typeof Highcharts) {
  // disable onSeriesAfterRender (only used for broken axis to trigger millions of useless events in seriesDrawBreaks, huge performance issue)
  // @ts-expect-error
  const onSeriesAfterRender = H.Series.prototype.hcEvents?.afterRender?.[0]?.fn;

  if (onSeriesAfterRender) {
    console.debug(`[Highcharts] removing ${onSeriesAfterRender.name} from H.Series afterRender`);
    H.removeEvent(H.Series, "afterRender", onSeriesAfterRender);

    window.setTimeout(() => {
      // @ts-expect-error
      if (H.Series.prototype.hcEvents?.afterRender?.length > 0)
        throw new Error(`[Highcharts] H.Series afterRender is not empty after patch`);
    }, 0);
  } else {
    window.setTimeout(() => {
      throw new Error(`[Highcharts] H.Series afterRender is empty before patch`);
    });
  }

  // disable onSeriesAfterAnimate (only used for broken axis to re-render points in interval, useless to us and crashes on break creation)
  // @ts-expect-error
  const afterGeneratePoints = H.Series.prototype.hcEvents?.afterGeneratePoints?.[0]?.fn;

  if (afterGeneratePoints) {
    console.debug(
      `[Highcharts] removing ${afterGeneratePoints.name} from H.Series afterGeneratePoints`,
    );
    H.removeEvent(H.Series, "afterGeneratePoints", afterGeneratePoints);

    window.setTimeout(() => {
      // @ts-expect-error
      if (H.Series.prototype.hcEvents?.afterGeneratePoints?.length > 0)
        throw new Error(`[Highcharts] H.Series afterGeneratePoints is not empty after patch`);
    }, 0);
  } else {
    window.setTimeout(() => {
      throw new Error(`[Highcharts] H.Series afterGeneratePoints is empty before patch`);
    });
  }

  // disable onSeriesUpdatedData (bug in diagnosis, function is useless for us anyway)
  // https://github.com/highcharts/highcharts/blob/2decde36d887bf37433c71461e0300ec4685e144/ts/Core/Axis/OrdinalAxis.ts#L766
  // xAxis.options is undefined
  // this function was added here:
  // https://github.com/highcharts/highcharts/issues/16055
  // @ts-expect-error
  const onSeriesUpdatedData = H.Series.prototype.hcEvents?.updatedData?.[0]?.fn;

  if (onSeriesUpdatedData) {
    console.debug(`[Highcharts] removing ${onSeriesUpdatedData.name} from H.Series updatedData`);
    H.removeEvent(H.Series, "updatedData", onSeriesUpdatedData);

    window.setTimeout(() => {
      // @ts-expect-error
      if (H.Series.prototype.hcEvents?.afterRender?.length > 0)
        throw new Error(`[Highcharts] H.Series updatedData is not empty after patch`);
    }, 0);
  } else {
    window.setTimeout(() => {
      throw new Error(`[Highcharts] H.Series updatedData is empty before patch`);
    });
  }
}
